module.exports = __webpack_public_path__ + "img/470.981a4b9f.png";